import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import { round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';

const moDistribution = observable({
  empty: false,
  timeActive: <number | string>'',
  list: <any[]>[],
  maxValue: 0,
  totalValue: 0,
  declineCount: 0,
  declineRate: 0,
  increaseCount: 0,
  increaseRate: 0,
});

const distributionInit = action(async (res: any) => {
  if (isEmpty(res)) {
    moDistribution.empty = true;
    return;
  }
  moDistribution.empty = false;
  // console.log('人员配置 变化率分布 -- ', res);
  let max = 0;
  let total = 0;

  res.distribution.map((item: any) => {
    if (item.count > max) max = item.count;
    total += item.count;
  });
  let empty = false;
  res.distribution?.map((item: any) => {
    if (item.count > 0) empty = true;
  });

  runInAction(() => {
    if (empty) moDistribution.list = res.distribution;
    else moDistribution.list = [];
    moDistribution.maxValue = max;
    moDistribution.totalValue = total;
    moDistribution.declineCount = res.decline_count;
    moDistribution.declineRate = res.decline_rate;
    moDistribution.increaseCount = res.increase_count;
    moDistribution.increaseRate = res.increase_rate;
  });
});

const timeTabChange = action(async (value: number | string, change?:boolean) => {
  runInAction(() => {
    moDistribution.timeActive = value;
  });
  localStorage.setItem('settleRatioYear', value.toString());
  if (change) return;
  toggleValue('isLoading', true);
  setTimeout(() => {
    toggleValue('isLoading', false);
  }, 10000);
  const res: any = await EffectService.settleRatio({
    year: moDistribution.timeActive,
  });
  if (isEmpty(res)) {
    toggleValue('isLoading', false);
  }
  await distributionInit(res);
  toggleValue('isLoading', false);
});

export default moDistribution;
export {
  distributionInit, timeTabChange,
};
